module.exports = __webpack_public_path__ + "img/160.c59758ca.jpg";